import { render, staticRenderFns } from "./remember-password-form.vue?vue&type=template&id=3650b388&scoped=true&"
import script from "./remember-password-form.vue?vue&type=script&lang=js&"
export * from "./remember-password-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3650b388",
  null
  
)

export default component.exports